import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Buscás planillas en internet y encontrás formatos en inglés que no se adaptan a tu práctica', 'Creás materiales desde cero que te llevan horas que deberían ir a la atención', 'Tenés la teoría ABA pero no sabés cómo traducirla a un registro que funcione en la vida real', 'Llegás a reuniones con familias sin saber exactamente qué decir', 'Los informes para la Obra Social te llevan una tarde entera cada mes', 'Empezás a organizarte, la vida cotidiana lo interrumpe y volvés a improvisar', 'Cada paciente nuevo te genera la misma angustia: ¿por dónde empiezo?'];
  return <section className="py-20 bg-cyan-950" data-id="element-232">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-234">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-235">
            ¿Cuántas veces más vas a llegar a una sesión sin saber exactamente
            qué hacer?
          </h2>

          <div className="space-y-6 text-lg text-cyan-100 text-left md:text-center max-w-3xl mx-auto" data-id="element-236">
            <p className="text-[14px]" data-id="element-237">
              Querés trabajar bien. Tal vez tenés un paciente nuevo con TEA, un
              niño con conductas desafiantes que no entendés, un caso que no
              avanza o una familia que no sabe cómo acompañar.
            </p>
            <p data-id="element-238">
              <strong className="text-white text-[16px]" data-id="element-239">
                Pero nadie te dijo que armar material ABA profesional desde cero
                iba a ser tan agotador.
              </strong>
            </p>
            <p className="text-[14px]" data-id="element-240">
              Buscás artículos en inglés que no aplican al contexto argentino.
              Diseñás planillas que llevan horas. Comprás libros que son solo
              teoría. Y seguís llegando a las sesiones con algo armado a las
              apuradas o con la sensación de que "algo le falta" al plan.
            </p>
            <p className="font-bold text-white pt-4 text-[14px]" data-id="element-241">
              No es falta de conocimiento. Es falta de un sistema.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-red-950/40 border border-red-900/60 rounded-2xl p-6 md:p-8" data-id="element-242">
          <ul className="space-y-4" data-id="element-243">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-244">
                <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-245">
                  <X className="w-4 h-4 text-red-400" data-id="element-246" />
                </div>
                <span className="text-cyan-50 font-medium text-[14px]" data-id="element-247">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-248">
          <p className="font-bold text-cyan-300 text-[16px]" data-id="element-249">
            ¿Y si este fuera el último día que trabajás sin un sistema
            profesional completo?
          </p>
        </div>
      </div>
    </section>;
}